module.exports = "<div class=\"ubg-banner-message mat-body-2\">\n  <ng-content></ng-content>\n</div>"